import React from 'react';
import { Container } from '../../../components/web/container/container';
import { WebFooterContent } from './content/web-footer-content';

export const Footer: React.FC = () => {
    return (
        <footer className="flex flex-row py-[5rem]">
            <Container>
                <WebFooterContent />
            </Container>
        </footer>
    );
};
